import * as React from "react";
export const ConfigurationContext = React.createContext({});
export const PanelsContext = React.createContext({});
export const PanelsFramesContext = React.createContext({});
export const PlotsContext = React.createContext({});
export const EbroContext = React.createContext({});
export const CdmContext = React.createContext({});
export const NdmContext = React.createContext({});
export const ProgramContext = React.createContext({});
export const ProgramsContext = React.createContext({});
export const ProgramviewContext = React.createContext({});
export const PromptContext = React.createContext({});
export const RunProgramContext = React.createContext({});
export const RedirectContext = React.createContext({});
export const ScenarioContext = React.createContext({});
export const SchemasContext = React.createContext({});
export const SchemasFramesContext = React.createContext({});
export const StdoutContext = React.createContext({});
export const FilesContext = React.createContext({});
export const UISchemasContext = React.createContext({});
export const UISchemasFramesContext = React.createContext({});
export const NotificationContext = React.createContext({});
export const UserContext = React.createContext({});
export const LicenseContext = React.createContext({});
export const AutofocusTasksContext = React.createContext({});
export const AutofocusJobsContext = React.createContext({});
export const EventsLoggerContext = React.createContext({});
export const FileBrowserHeadersContext = React.createContext({});
export const FileBrowserFilesContext = React.createContext({});
export const FileBrowserNapeosContext = React.createContext({});
export const RViewerContext = React.createContext({});
export const GrafosContext = React.createContext({});
export const GrafosDataContext = React.createContext({});
export const ImageContext = React.createContext({});
export const modeFocusContext = React.createContext({});
export const UploadDataContext = React.createContext({});
export const IncomingFileBrowserHeadersContext = React.createContext({});
export const OutgoingContext = React.createContext({});
export const DashboardContext = React.createContext({});
export const AFViewsContext = React.createContext({});
export const AccessLevelesContext = React.createContext({});
export const PanelEditableContext = React.createContext(false);
export const VisualFocusConfigContext = React.createContext({
    scenario: "",
    cfg: "",
});
export const TabTitleContext = React.createContext({});
//# sourceMappingURL=index.js.map